export function BackgroundPattern() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 321 94">
      <defs>
        <linearGradient
          x1="192.15"
          x2="321.6"
          y1="130.04"
          y2="0.6"
          gradientUnits="userSpaceOnUse"
          id="linearGradient-left">
          <stop offset="0" stopColor="#fff" stopOpacity="0.1" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          x1="-14.04"
          x2="45.24"
          y1="46.23"
          y2="-13.05"
          gradientUnits="userSpaceOnUse"
          id="linearGradient-right">
          <stop offset="0" stopColor="#fff" stopOpacity="0.1" />
          <stop offset="0.04" stopColor="#fff" stopOpacity="0.12" />
          <stop offset="0.7" stopColor="#fff" stopOpacity="0.16" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <path
        d="M243.74 2.17L245.91 0h15.58l-10 10a5.51 5.51 0 01-7.79-7.79zM297 67.81a5.37 5.37 0 00-1.65-3.87 5.69 5.69 0 00-7.93 0L256.67 94h15.86l22.83-22.31a5.4 5.4 0 001.64-3.88zm16.23 1.55L288.62 94h16.07L321 77.69v-8.56a5.65 5.65 0 00-7.76.23zM228.38 33a5.54 5.54 0 10-7.84-7.84l-.14.15-.11.11-.73.73-.26.25-.58.59L170 75.8l-1.25 1.2-1.54 1.53-.43.43-.17.17-.4.41A53 53 0 00156.12 94h12.66a42.91 42.91 0 015.34-6.67zm-23.53 58.31a5.44 5.44 0 00-1.64-3.88 5.71 5.71 0 00-7.93 0l-4.85 4.75-.5.48-1.36 1.34h15.53a5.27 5.27 0 00.75-2.69zm94.91-43.24a5.56 5.56 0 107.86 7.87L321 42.54V26.8zM266.33 28a5.6 5.6 0 00-9.56-3.95L210 70.9a5.59 5.59 0 107.91 7.91L264.69 32a5.53 5.53 0 001.64-4zm40.47-6.87a5.53 5.53 0 00-5.53-5.53H301a5.45 5.45 0 00-3.63 1.61L278.42 36.2a5.53 5.53 0 107.82 7.8l18.94-18.94a5.48 5.48 0 001.62-3.89zM269 48.47a5.74 5.74 0 00-4.07 1.68l-14.49 14.48a5.76 5.76 0 108.14 8.15l14.49-14.48a5.78 5.78 0 000-8.15 5.77 5.77 0 00-4.07-1.68zm-26.48 38a5.67 5.67 0 00-4-9.67h-.28a5.67 5.67 0 00-3.73 1.65L219 94h16zm26.55-71.75a5.56 5.56 0 009.49 3.93L297.21 0h-15.72l-10.8 10.8a5.53 5.53 0 00-1.63 3.93zm41.77-7.22a5.83 5.83 0 0010 4.13l.2-.19V0h-5.08l-3.37 3.38a5.75 5.75 0 00-1.75 4.12z"
        fill="url(#linearGradient-left)"
      />
      <path
        d="M12.91 48.19A3.59 3.59 0 0014 45.62a3.55 3.55 0 00-1.09-2.56 3.81 3.81 0 00-5.27 0L1 49.55l-1 .92v9.11a36.48 36.48 0 006.27-4.93zM25.09 26a3.89 3.89 0 00-2.77 1.15l-4.17 4.17a3.91 3.91 0 105.53 5.53l4.17-4.17A3.92 3.92 0 0025.09 26zM5 6.62A3.62 3.62 0 001.38 3h-.22A3.57 3.57 0 000 3.28v9.84l3.94-3.94A3.62 3.62 0 005 6.62zM28.39 0L13.14 14.73l-2 1.95L0 27.4v10.33C10.83 27.29 34.49 4.45 39.1 0zM32 19.17a3.84 3.84 0 006.55 2.71L57.88 2.55A3.81 3.81 0 0059 0h-9.43L33.13 16.45A3.81 3.81 0 0032 19.17z"
        fill="url(#linearGradient-right)"
      />
    </svg>
  )
}
